import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localePt from '@angular/common/locales/pt';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected title = 'galia-front-end';
  private translate: TranslateService = inject(TranslateService);

  constructor() {
    registerLocaleData(localeFr, 'fr');
    registerLocaleData(localeEn, 'en');
    registerLocaleData(localeEs, 'es');
    // Angular's `pt` locale data is Brazilian Portuguese.
    registerLocaleData(localePt, 'pt-BR');

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any)['lang'] = (lang: string) => {
      this.translate.use(lang);
    };
  }
}
